function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPromotionCouponRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28 4a2 2 0 012 2v8a2 2 0 000 4v8a2 2 0 01-2 2H4a2 2 0 01-2-2v-8a2 2 0 000-4V6a2 2 0 012-2h24zM4 12.537a3.998 3.998 0 010 6.926V26h24v-6.537a3.999 3.999 0 010-6.926V6H4v6.537zM12 20v4h-2v-4h2zm0-2h-2v-4h2v4zm0-6h-2V8h2v4z",
    fill: props.color
  }));
}

export default SvgIconPromotionCouponRexOutline;